import { formatarQtd } from "../../../lib/unidadeVenda";

const BRL = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits: 2, maximumFractionDigits: 2 });
const INT = new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 0 });

export const formatCurrency = (v) => BRL.format(Number(v) || 0);
export const formatInt = (v) => INT.format(Number(v) || 0);

// Quantidade vendida com a unidade (30/09/2026): "1,250 kg", "0,500 L" ou "12 un".
// `unidade` vem do servidor em cada produto ("kg" / "L" / null).
export const formatQtd = (v, unidade) => (unidade ? formatarQtd(v, unidade) : `${formatarQtd(v, null)} un`);
export const porUnidade = (unidade) => `/${unidade || "un"}`;

// Rótulo curto em cima de barra/ponto: 850 · 1,2k · 12k.
export const formatCompacto = (v) => {
  const n = Number(v) || 0;
  if (Math.abs(n) >= 1000) return `${(n / 1000).toFixed(Math.abs(n) >= 10000 ? 0 : 1).replace(".", ",")}k`;
  return n.toFixed(0);
};

// Valor em reais sem centavos, para caber embaixo do dia no gráfico.
export const formatReaisCurto = (v) => `R$ ${(Number(v) || 0).toLocaleString("pt-BR", { maximumFractionDigits: 0 })}`;

export const formatPct = (v, casas = 1) => (v == null ? "—" : `${Number(v).toFixed(casas).replace(".", ",")}%`);
